import React from "react";
import { useLocation } from "react-router-dom";
import "./css/index.css";

type ViewLoactionType = {
  state: {
    sub: string;
    content: string;
    img: string;
    type: string;
    prjt_nm: string;
    link: string;
  };
};

function PortFolioView() {
  const {
    state: { sub, content, img, type, prjt_nm, link },
  } = useLocation() as ViewLoactionType;

  return (
    <main className="portfolio-view-page">
      <div className="wrapper">
        <div className="header">
          <div className="left">추가소개</div>
          <a className="right" href={link} target="_blank">
            <div className="title">포트폴리오 링크 이동</div>
            <div className="img">
              <img src="/assets/common/backarrow.svg" alt=""></img>
            </div>
          </a>
        </div>
        <div className="title">프로젝트</div>
        <div className="box">
          <div
            className="back-img"
            style={{ backgroundImage: `url(${img})` }}
          />

          <div className="text">{prjt_nm}</div>
        </div>
        <div className="content">
          <div className="number">01</div>
          <div className="title">
            {type === "prjt"
              ? `유사프로젝트 참여 경험이 있나요? 그 프로젝트에서 자신의 역할은 무엇인가요?`
              : "밋업 신청 전 팀플리더에게 궁금한 점이 있나요?"}
          </div>
          <div className="textbox">
            <div className="text">{sub}</div>
          </div>
        </div>
        <div className="content2">
          <div className="number">02</div>
          <div className="title">
            {type === "prjt"
              ? `지원시 팀플리더가 요청한 필수정보는 여기에 작성해주세요.`
              : "밋업 신청 전 팀플리더에게 궁금한 점이 있나요?"}
          </div>
          <div className="textbox">
            <div className="text">{content}</div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default PortFolioView;
